import { http, camelify } from '../rest';

export function fetch(http, camelify, demo) {
  return {
    async execute(userId, startDate) {
      let data;
      if (demo) {
        const file = await import('./fetchInvestmentAccounts.data');
        data = file.default;
      } else {
        const startDateParam = startDate ? `&start_date=${startDate}` : '';
        data = (await http.get(`/investment_accounts?user_id=${userId}${startDateParam}`)).data;
      }
      return camelify(data);
    },
  };
}

export default fetch(http, camelify, process.env.DEMO);
